import { TFunction } from 'i18next'
import { StringSchema } from 'yup'

import { nonEmptyStringSchema, stringSchema } from '@/Shared/ui/form/validations'
import { formTranslation } from '@/Shared/ui/sharedTranslation'

export const urlSchema = (
  t: TFunction<'translation', undefined>,
  isRequired = true,
): StringSchema<string | undefined> => {
  const schema = isRequired ? nonEmptyStringSchema(t, 255) : stringSchema(t, 255)

  const rUrl = isRequired
    ? /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;&:=+$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;&:=+$,\w]+@)[A-Za-z0-9.-]+)((?:\/[+~%/.\w-_]*)?\??(?:[-+=&;%@.\w_]*)#?(?:[\w]*))?)/
    : /^$|((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;&:=+$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;&:=+$,\w]+@)[A-Za-z0-9.-]+)((?:\/[+~%/.\w-_]*)?\??(?:[-+=&;%@.\w_]*)#?(?:[\w]*))?)/

  return schema.matches(rUrl, t(formTranslation.errors.invalidFormat))
}
